'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = widgetUi;

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _WidgetUi = require('conversations-schema/records/WidgetUi');

var _WidgetUi2 = _interopRequireDefault(_WidgetUi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TOGGLE_OPEN = _ActionTypes2.default.TOGGLE_OPEN;
function widgetUi() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _WidgetUi2.default)();
  var action = arguments[1];

  switch (action.type) {
    case TOGGLE_OPEN:
      return state.set('open', action.payload.isOpened);
    default:
      return state;
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers/widgetUi.js
// module id = 417
// module chunks = 0 1